module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/brand-icons-ec3cfddedb8bebd2d7a3fdf511f7c1cc.woff";